import React from 'react';
import { CalendarDaysIcon, ClipboardCheckIcon, ClockIcon, CompassIcon, FolderOpenIcon, HelpCircleIcon, LayersIcon, MapIcon, NotebookPenIcon, RefreshCwIcon, ShuffleIcon, TimerIcon } from 'lucide-react';
import type { IconKey } from '../types/content';
const map = {
  help: HelpCircleIcon,
  folder: FolderOpenIcon,
  shuffle: ShuffleIcon,
  clock: ClockIcon,
  refresh: RefreshCwIcon,
  compass: CompassIcon,
  layers: LayersIcon,
  checklist: ClipboardCheckIcon,
  map: MapIcon,
  journal: NotebookPenIcon,
  calendar: CalendarDaysIcon,
  timer: TimerIcon
};
type IconByKeyProps = {
  icon: IconKey;
  className?: string;
};
export function IconByKey({
  icon,
  className
}: IconByKeyProps) {
  const Icon = map[icon];
  return <Icon className={className} aria-hidden="true" data-id="element-184" data-mp="24erd7kdb6m15" />;
}